import React, { Component } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from "./Pages/home";
import Mint from "./Pages/mint";
 
function App() {

	return (
		<div>
			<BrowserRouter>
				<Routes>

					<Route path='/' element={<Home />} />
					<Route path='mint' element={<Mint />} />
 
				</Routes>
			</BrowserRouter>
			<div>
			</div>
		</div>
	)
}


export default App;
